module.exports = __webpack_public_path__ + "img/close-dark-old.9c83996f.svg";